import * as yup from 'yup';
import { RegisterFormVariants } from './LaunchingRegisterForm.types';

const phoneRegExp = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

export const getRegisterFormSchema = Object.freeze({
  [RegisterFormVariants.AcheteurPublicPhysique]: yup.object().shape({
    firstName: yup.string().required('Le prénom est requis'),
    lastName: yup.string().required('Le nom est requis'),
    email: yup
      .string()
      .email('Adresse email est invalide')
      .required('Une adresse email est requise'),
    phone: yup
      .string()
      .matches(phoneRegExp, 'Numéro de téléphone invalide')
      .required('Un numéro de téléphone est requis.'),
    organization: yup.string().required('Ce champs est requis'),
    function: yup.string().required('Ce champs est requis'),
    persons: yup.number().required('Ce champs est requis'),
    newsletter: yup.boolean(),
  }),
  [RegisterFormVariants.AcheteurPublicLive]: yup.object().shape({
    firstName: yup.string().required('Le prénom est requis'),
    lastName: yup.string().required('Le nom est requis'),
    email: yup
      .string()
      .email("Le format de l'adresse email est invalide")
      .required('Une adresse email est requise'),
    phone: yup
      .string()
      .matches(phoneRegExp, 'Numéro de téléphone invalide')
      .required('Un numéro de téléphone est requis.'),
    organization: yup.string().required('Ce champs est requis'),
    function: yup.string().required('Ce champs est requis'),
    newsletter: yup.boolean(),
  }),
  [RegisterFormVariants.CommercialFormation]: yup.object().shape({
    firstName: yup.string().required('Le prénom est requis'),
    lastName: yup.string().required('Le nom est requis'),
    email: yup
      .string()
      .email("Le format de l'adresse email est invalide")
      .required('Une adresse email est requise'),
    phone: yup
      .string()
      .matches(phoneRegExp, 'Numéro de téléphone invalide')
      .required('Un numéro de téléphone est requis.'),
    company: yup.string().required('Ce champs est requis'),
    siret: yup.string().required('Ce champs est requis'),
    tva: yup.string().required('Ce champs est requis'),
    formations: yup.string().required('Ce champs est requis'),
    department: yup.string().required('Ce champs est requis'),
    newsletter: yup.boolean(),
  }),
});

export const getRegisterFormSchemaOld = (variant: RegisterFormVariants) => {
  switch (variant) {
    case RegisterFormVariants.AcheteurPublicPhysique:
      return yup.object().shape({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        email: yup.string().email("Le format de l'adresse email est invalide").required(),
        phone: yup.string().required(),
        company: yup.string().required(),
        function: yup.string().required(),
        persons: yup.number().required(),
        // newsletter: yup.boolean()
      });
    case RegisterFormVariants.AcheteurPublicLive:
      return yup.object().shape({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        email: yup.string().email("Le format de l'adresse email est invalide").required(),
        phone: yup.string().required(),
        company: yup.string().required(),
        function: yup.string().required(),
        persons: yup.number().required(),
        // newsletter: yup.boolean()
      });
    case RegisterFormVariants.CommercialFormation:
      return yup.object().shape({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        email: yup.string().email("Le format de l'adresse email est invalide").required(),
        phone: yup.string().required(),
        company: yup.string().required(),
        function: yup.string().required(),
        persons: yup.number().required(),
        // newsletter: yup.boolean(),
      });
    default:
      return yup.object().shape({
        firstName: yup.string().required(),
        lastName: yup.string().required(),
        email: yup.string().email("Le format de l'adresse email est invalide").required(),
        phone: yup.string().required(),
        company: yup.string().required(),
        function: yup.string().required(),
        persons: yup.number().required(),
        // newsletter: yup.boolean()
      });
  }
};
